import { 
  Box, 
  Button, 
  VStack, 
  Text, 
  FormControl, 
  FormLabel, 
  Input,
  FormErrorMessage,
  SimpleGrid,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useAddShift, useEditShift } from "../../services/configurationService";
import { calcTime, tConvert } from "../../utils";
import { FiClock } from "react-icons/fi";

const AddShift = ({ closeModal, editShift, todo, refetchGetShift }) => {
  const [inputData, setInputData] = useState({ name: "", from: "", to: "" });
  const [errors, setErrors] = useState({});
  
  const { addShiftIsLoading, addShiftPayload } = useAddShift((res) => {
    refetchGetShift();
    closeModal();
  });
  const { editShiftIsLoading, editShiftPayload } = useEditShift((res) => {
    refetchGetShift();
    closeModal();
  });

  const validateForm = () => {
    const newErrors = {};
    if (!inputData.name.trim()) {
      newErrors.name = "Shift name is required";
    }
    if (!inputData.from) {
      newErrors.from = "Start time is required";
    }
    if (!inputData.to) {
      newErrors.to = "End time is required";
    }
    if (inputData.from && inputData.to && inputData.from >= inputData.to) {
      newErrors.to = "End time must be after start time";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    const payload = {
      id: todo === "edit" ? editShift?.id : "",
      name: inputData.name.trim(),
      from_time: tConvert(inputData.from, false),
      to_time: tConvert(inputData.to, false),
    };

    if (todo === "new") {
      addShiftPayload(payload);
    } else {
      editShiftPayload(payload);
    }
  };

  useEffect(() => {
    if (editShift?.name) {
      setInputData({
        name: editShift.name,
        from: calcTime(editShift.from_time).replace(" ", ""),
        to: calcTime(editShift.to_time).replace(" ", "")
      });
    }
  }, [editShift]);

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <VStack spacing={6} align="stretch">
          {/* Header */}
          <VStack spacing={2} align="center">
            <Box
              p={3}
              borderRadius="12px"
              bg="orange.50"
              color="orange.600"
              border="1px solid"
              borderColor="orange.200"
            >
              <FiClock size={24} />
            </Box>
            <VStack spacing={1}>
              <Text fontSize="lg" fontWeight="600" color="gray.900">
                {todo === "edit" ? "Edit" : "Add"} Shift
              </Text>
              <Text fontSize="sm" color="gray.500" textAlign="center">
                {todo === "edit" ? "Update shift information" : "Enter shift details"}
              </Text>
            </VStack>
          </VStack>

          {/* Form Fields */}
          <FormControl isInvalid={!!errors.name}>
            <FormLabel fontSize="sm" fontWeight="500" color="gray.700">
              Shift Name
            </FormLabel>
            <Input
              placeholder="Enter shift name (e.g., Morning Shift)"
              value={inputData.name}
              onChange={(e) => setInputData({ ...inputData, name: e.target.value })}
              borderRadius="12px"
              borderColor="gray.200"
              _focus={{ borderColor: "orange.500", boxShadow: "0 0 0 1px var(--chakra-colors-orange-500)" }}
              _hover={{ borderColor: "gray.300" }}
              size="lg"
            />
            <FormErrorMessage>{errors.name}</FormErrorMessage>
          </FormControl>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
            <FormControl isInvalid={!!errors.from}>
              <FormLabel fontSize="sm" fontWeight="500" color="gray.700">
                Start Time
              </FormLabel>
              <Input
                type="time"
                value={inputData.from}
                onChange={(e) => setInputData({ ...inputData, from: e.target.value })}
                borderRadius="12px"
                borderColor="gray.200"
                _focus={{ borderColor: "orange.500", boxShadow: "0 0 0 1px var(--chakra-colors-orange-500)" }}
                _hover={{ borderColor: "gray.300" }}
                size="lg"
              />
              <FormErrorMessage>{errors.from}</FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={!!errors.to}>
              <FormLabel fontSize="sm" fontWeight="500" color="gray.700">
                End Time
              </FormLabel>
              <Input
                type="time"
                value={inputData.to}
                onChange={(e) => setInputData({ ...inputData, to: e.target.value })}
                borderRadius="12px"
                borderColor="gray.200"
                _focus={{ borderColor: "orange.500", boxShadow: "0 0 0 1px var(--chakra-colors-orange-500)" }}
                _hover={{ borderColor: "gray.300" }}
                size="lg"
              />
              <FormErrorMessage>{errors.to}</FormErrorMessage>
            </FormControl>
          </SimpleGrid>

          {/* Submit Button */}
          <Button
            type="submit"
            colorScheme="orange"
            size="lg"
            borderRadius="12px"
            fontWeight="600"
            isLoading={addShiftIsLoading || editShiftIsLoading}
            loadingText={todo === "edit" ? "Updating..." : "Adding..."}
            _hover={{ transform: "translateY(-1px)", boxShadow: "lg" }}
            transition="all 0.2s"
          >
            {todo === "edit" ? "Update Shift" : "Add Shift"}
          </Button>
        </VStack>
      </form>
    </Box>
  );
};

export default AddShift;
